import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "51",
  viewBox: "0 0 74 51"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("text", {
  fill: "#f59600",
  "font-family": "RakutenSansUI-Bold, Rakuten Sans UI",
  "font-size": "40",
  "font-weight": "700"
}, [
  /*#__PURE__*/_createElementVNode("tspan", {
    x: "-13.3",
    y: "41"
  }, " R")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };